export const TaggingSettingModel = Symbol.for('TaggingSettingModel');
